var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 8,
    viewBox: "0 0 15 8",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m.318291.304826c-.424388.352104-.424388.946404 0 1.298504l6.275709 5.2068c.35204.29208.88226.32043 1.26889.08504.08512-.03783.16547-.08693.23821-.14728l6.2757-5.2068c.4244-.3521.4244-.946404 0-1.298509-.3899-.3234779-.9983-.3234783-1.3882 0l-5.67856 4.711379-5.60356-4.649134c-.38988-.3234784-.998303-.3234784-1.388189 0z",
    fill: "#4d4f53",
    fillOpacity: 0.5,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleLogo);
export default __webpack_public_path__ + "static/media/toggle-logo.7e9c2d902a6b4a4083bc52172b38e437.svg";
export { ForwardRef as ReactComponent };